(ns story-builder.util.dom
  (:require
   [clojure.string :as str]))

(defn deg-from-matrix
  [matrix-string]
  (let [[a b _ _] (->> (-> (str/split matrix-string #"\(")
                           (second)
                           (str/split #"\)")
                           (first)
                           (str/split #","))
                       (mapv js/parseFloat))
        deg       (-> (js/Math.atan2 b a)
                      (* (/ 180 js/Math.PI)))]
    deg))

(defn deg-rotation [el]
  (when (instance? js/Element el)
    (let [style     (js/getComputedStyle el nil)
          transform (.getPropertyValue style "transform")]
      (if (= transform "none")
        0
        (deg-from-matrix transform)))))

(defn rect [el]
  (let [rect           (.getBoundingClientRect el)
        computed-style (js/getComputedStyle el nil)
        offset-left    (-> (.-left computed-style)
                           (str/replace #"px" "")
                           (js/parseFloat))
        offset-top     (-> (.-top computed-style)
                           (str/replace #"px" "")
                           (js/parseFloat))
        offset-width   (-> (.-width computed-style)
                           (str/replace #"px" "")
                           (js/parseFloat))
        offset-height  (-> (.-height computed-style)
                           (str/replace #"px" "")
                           (js/parseFloat))
        ar             (/ offset-width offset-height)
        corners        [[offset-left offset-top]
                        [(+ offset-left offset-width) offset-top]
                        [(+ offset-left offset-width) (+ offset-top offset-height)]
                        [offset-left (+ offset-top offset-height)]]]
    {:left     (.-left rect)
     :top      (.-top rect)
     :right    (+ (.-width rect) (.-left rect))
     :bottom   (+ (.-height rect) (.-top rect))
     :width    (.-width rect)
     :height   (.-height rect)
     :ar       ar
     :corners  corners
     :rotation (deg-rotation el)
     :z-index  (js/parseInt (.. el -style -zIndex))}))

(defn highlight-rect
  "This function is a useful utility for debugging. It is not used as part of the application."
  ([rect-or-points]
   (highlight-rect rect-or-points {:color "red"}))
  ([rect-or-points {:keys [color
                           origin
                           scene-selector]
                    :or   {color "red"}}]
   (let [canvas     (.createElement js/document "canvas")
         ctx        (.getContext canvas "2d")
         scene-rect (when scene-selector
                      (rect (js/document.querySelector scene-selector)))]
     (.appendChild js/document.body canvas)
     (aset canvas "width" (.-innerWidth js/window))
     (aset canvas "height" (.-innerHeight js/window))
     (aset canvas "style" "position: fixed; top: 0; left: 0; pointer-events: none; z-index: 99999")
     (aset ctx "fillStyle" color)
     (cond
       (map? rect-or-points)
       (let [top    (+ (:top rect-or-points) (:top scene-rect))
             bottom (+ (:bottom rect-or-points) (:top scene-rect))
             right  (+ (:right rect-or-points) (:left scene-rect))
             left   (+ (:left rect-or-points) (:left scene-rect))]
         (.beginPath ctx)
         (.arc ctx left top 2 0 (* 2 Math/PI) true)
         (.fill ctx)
         (.beginPath ctx)
         (.arc ctx right top 2 0 (* 2 Math/PI) true)
         (.fill ctx)
         (.beginPath ctx)
         (.arc ctx left bottom 2 0 (* 2 Math/PI) true)
         (.fill ctx)
         (.beginPath ctx)
         (.arc ctx right bottom 2 0 (* 2 Math/PI) true)
         (.fill ctx))
       (vector? rect-or-points)
       (doseq [point rect-or-points]
         (let [x (+ (first point) (:left scene-rect))
               y (+ (second point) (:top scene-rect))]
           (.beginPath ctx)
           (.arc ctx x y 4 0 (* 2 Math/PI) true)
           (.fill ctx))))
     (when origin
       (let [x (+ (first origin) (:left scene-rect))
             y (+ (second origin) (:top scene-rect))]
         (aset ctx "fillStyle" "green")
         (.beginPath ctx)
         (.arc ctx x y 4 0 (* 2 Math/PI) true)
         (.fill ctx))))))
